(function () {
  if (window.__namoosScrollInit) return;
  window.__namoosScrollInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer;

  function show(el) {
    el.classList.add('is-visible');
    if (observer) observer.unobserve(el);
  }

  function reveal(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      show(entry.target);
    });
  }

  function createObserver() {
    return new IntersectionObserver(reveal, {
      threshold: 0.08,
      rootMargin: '0px 0px -6% 0px'
    });
  }

  function applyDelay(el, index) {
    var custom = el.getAttribute('data-namoos-delay');
    if (custom !== null) {
      el.style.transitionDelay = custom;
      return;
    }
    el.style.transitionDelay = (index * 0.1) + 's';
  }

  function initReveal(root) {
    var scope = root || document;
    var targets = scope.querySelectorAll('.namoos-reveal, [data-namoos-reveal]');

    if (reduceMotion) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      scope.querySelectorAll('.namoos-reveal-stagger > *').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    if (!observer) observer = createObserver();

    targets.forEach(function (el) {
      if (el.classList.contains('is-visible')) return;
      observer.observe(el);
    });

    scope.querySelectorAll('.namoos-reveal-stagger').forEach(function (wrap) {
      Array.prototype.forEach.call(wrap.children, function (child, i) {
        if (child.classList.contains('is-visible')) return;
        applyDelay(child, i);
        observer.observe(child);
      });
    });

    scope.querySelectorAll('.x-container-scrolling-banner-content').forEach(function (el) {
      var section = el.closest('.shopify-section');
      if (!section || section.classList.contains('is-visible')) return;
      section.classList.add('namoos-reveal', 'namoos-reveal--ticker');
      observer.observe(section);
    });
  }

  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-namoos-count'));
    if (isNaN(target)) return;
    var suffix = el.getAttribute('data-namoos-suffix') || '';
    var prefix = el.getAttribute('data-namoos-prefix') || '';
    var decimals = parseInt(el.getAttribute('data-namoos-decimals') || '0', 10);
    var duration = 1200;
    var start = 0;
    var startTime = null;
    function step(ts) {
      if (!startTime) startTime = ts;
      var p = Math.min((ts - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = start + (target - start) * eased;
      el.textContent = prefix + val.toFixed(decimals) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCounters(root) {
    if (reduceMotion) return;
    var scope = root || document;
    var counterObserver = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        animateCount(entry.target);
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.5 });
    scope.querySelectorAll('[data-namoos-count]').forEach(function (el) {
      counterObserver.observe(el);
    });
  }

  function initStickyBuy(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-namoos-sticky-buy]').forEach(function (bar) {
      if (bar.dataset.ready === 'true') return;
      bar.dataset.ready = 'true';

      var selector = bar.getAttribute('data-watch-selector') || '#shopify-section-slideshow_GAeAAc';
      var hero = document.querySelector(selector);
      if (!hero) {
        var sections = document.querySelectorAll('.shopify-section');
        hero = sections.length ? sections[0] : null;
      }
      if (!hero) return;

      var toggle = function (show) {
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('has-namoos-sticky-buy', show);
      };

      var stickyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          toggle(!entry.isIntersecting);
        });
      }, { threshold: 0 });

      stickyObserver.observe(hero);
    });
  }

  function init(root) {
    initReveal(root);
    initCounters(root);
    initStickyBuy(root);
  }

  function onReady() {
    init();
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
